/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('ecar.orderForm', [], function (el) {
        var buyFormBtn = document.querySelector('.controlButtons .buy');
        var reserveFormBtn = document.querySelector('.controlButtons .reserve');
        var buyForm = el.querySelector('.buyFormWrap');
        var reserveForm = el.querySelector('.reserveFormWrap');
        var buyCloseButton = el.querySelector('.forms .buyFormWrap .close');
        var reserveCloseButton = el.querySelector('.forms .reserveFormWrap .close');
        if (!reserveFormBtn || !buyFormBtn) {
            return;
        }
        var util = MoyaContainer.get('core.util');
        util.delegate(buyFormBtn, 'click', '.controlButtons .buy', function (e) {
            buyFormBtn.classList.toggle('active');
            reserveFormBtn.classList.remove('active');
            buyFormBtn.blur();
            buyForm.classList.toggle('open');
            reserveForm.classList.remove('open');
            if (buyFormBtn.classList.contains('active')) {
                setTimeout(function () {
                    buyForm.scrollIntoView({ behavior: "smooth" });
                }, 250);
            }
        });
        util.delegate(buyCloseButton, 'click', '.buyFormWrap .close', function (e) {
            buyFormBtn.click();
        });
        util.delegate(reserveFormBtn, 'click', '.controlButtons .reserve', function (e) {
            reserveFormBtn.classList.toggle('active');
            buyFormBtn.classList.remove('active');
            reserveFormBtn.blur();
            reserveForm.classList.toggle('open');
            buyForm.classList.remove('open');
            if (reserveFormBtn.classList.contains('active')) {
                setTimeout(function () {
                    reserveForm.scrollIntoView({ behavior: "smooth" });
                }, 250);
            }
        });
        util.delegate(reserveCloseButton, 'click', '.reserveFormWrap .close', function (e) {
            reserveFormBtn.click();
        });
        el.querySelectorAll('.buyFormWrap input[type="radio"]').forEach(function (radio) {
            util.delegate(radio, 'change', '#' + radio.id, function (e) {
                var value = (e.delegateTarget.getAttribute('value'));
                if (parseInt(value) === 1) {
                    el.querySelectorAll('.buyFormWrap .togglable').forEach(function (elm) {
                        elm.classList.add('open');
                        elm.querySelector('input').value = '';
                    });
                }
                else {
                    el.querySelectorAll('.buyFormWrap .togglable').forEach(function (elm) {
                        elm.classList.remove('open');
                    });
                }
                setTimeout(function () {
                    window.dispatchEvent(new Event('resize'));
                }, 250);
            });
        });
        el.querySelectorAll('.reserveFormWrap input[type="radio"]').forEach(function (radio) {
            util.delegate(radio, 'change', '#' + radio.id, function (e) {
                var value = (e.delegateTarget.getAttribute('value'));
                if (parseInt(value) === 1) {
                    el.querySelectorAll('.reserveFormWrap .togglable').forEach(function (elm) {
                        elm.classList.add('open');
                        elm.querySelector('input').value = '';
                    });
                }
                else {
                    el.querySelectorAll('.reserveFormWrap .togglable').forEach(function (elm) {
                        elm.classList.remove('open');
                    });
                }
                setTimeout(function () {
                    window.dispatchEvent(new Event('resize'));
                }, 250);
            });
        });
        var ssnFields = el.querySelectorAll('#kennitala');
        var resetValidity = function (e) {
            if (!e.target.validity.patternMismatch) {
                e.target.setCustomValidity('');
            }
        };
        ssnFields.forEach(function (field) {
            field.addEventListener('invalid', function (e) {
                var ssn = field.value;
                field.setCustomValidity('');
                if (!/^\d*$/g.test(ssn)) {
                    field.setCustomValidity('Kennitala má aðeins innihalda tölur, engin tákn');
                }
                else {
                    field.setCustomValidity('Kennitala þarf að innihalda 10 tölustafi');
                }
            });
            field.addEventListener('input', resetValidity);
            field.addEventListener('change', resetValidity);
            field.addEventListener('valid', resetValidity);
        });
        if (document.body.classList.contains('invalidBuy')) {
            buyFormBtn.click();
            buyForm.scrollIntoView();
        }
        if (document.body.classList.contains('invalidReserve')) {
            reserveFormBtn.click();
            reserveForm.scrollIntoView({ behavior: "smooth" });
        }
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
